// Mock data for Global Tech Solutions

export const company = {
  name: "Global Tech Solutions",
  tagline: "Your Partner in Technology",
  established: 2010,
  email: "sales@globaltechnologies.in",
  phone: "+91 77966 61177",
  address: "C4, 105, Skyi Star City Road, DSK Vishwa, Dhayari, Wanjalewadi, Pune, Maharashtra",
  registeredAddress: "C4, 105, Skyi Star City Road, DSK Vishwa, Dhayari, Wanjalewadi, Pune, Maharashtra",
  officeAddress: "403, 45 Street, above Atithi Veg Hotel, opposite Dmart, Veerbhadra Nagar, Baner, Pune, Maharashtra 411045",
  hours: [
    { day: "Monday", time: "9:00 AM – 6:00 PM" },
    { day: "Tuesday", time: "9:00 AM – 6:00 PM" },
    { day: "Wednesday", time: "9:00 AM – 6:00 PM" },
    { day: "Thursday", time: "9:00 AM – 6:00 PM" },
    { day: "Friday", time: "9:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 6:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const heroImage =
  "https://img1.wsimg.com/isteam/getty/1454435758/:/rs=w:1400,cg:true,m";

export const stats = [
  { value: "14+", label: "Years of Experience" },
  { value: "500+", label: "Projects Delivered" },
  { value: "200+", label: "Happy Clients" },
  { value: "24/7", label: "Support & AMC" },
];

export const services = [
  {
    slug: "it-networking",
    icon: "Network",
    title: "IT & Networking",
    short: "Turnkey networking and IT infrastructure engineered for uptime, scale and productivity.",
    description:
      "We design and create networking & IT infrastructure that helps your business maximise productivity, reduce operational cost and manage future scalability. Our specialists build resilient, redundant networks that optimize high availability and eliminate points of failure.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/ols/IT.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "boardroom-av",
    icon: "Presentation",
    title: "Boardroom AV & Automation",
    short: "Single-platform, integrated AV and automation for real-time collaborative working.",
    description:
      "In today's fast paced commercial environment, easy access to key information and seamless communication are fundamental. Global Tech designs & implements single-platform integrated solutions with leading edge audio-visual and automation.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/blob-3b24997.png/:/rs=w:900,cg:true",
  },
  {
    slug: "fire-alarm",
    icon: "Flame",
    title: "Fire Alarm Systems",
    short: "High-sensitivity detection and intelligent fire panels for early warning and safe evacuation.",
    description:
      "We design and deploy high sensitivity smoke detectors, heat detectors, intelligent fire panels, notification appliances and audio devices. Our systems integrate with access control and PA systems for safe evacuation.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/blob-f284c37.png/:/rs=w:900,cg:true",
  },
  {
    slug: "pa-system",
    icon: "Megaphone",
    title: "Public Address System",
    short: "Reliable PA and voice evacuation for facilities, factories and public buildings.",
    description:
      "High-quality public address and voice evacuation systems for transportation terminals, houses of worship, public buildings, medical facilities, office buildings, schools, shopping malls and industrial facilities.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/public-address-systems.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "amc",
    icon: "Wrench",
    title: "AMC – Support & Services",
    short: "Preventive maintenance and rapid response for BMS and IT assets.",
    description:
      "Top-notch IT & BMS services and AMC through our focused support team. Regular preventative maintenance visits keep your assets working optimally, and our service contracts provide peace of mind if a breakdown occurs.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/ols/AMC.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "access-control",
    icon: "Fingerprint",
    title: "Access Control Systems",
    short: "High-security access for data centres, IT facilities and sensitive premises.",
    description:
      "We deploy access control systems for data centers, government/military institutes, IT facilities and premises where movement of people must be captured. Advanced security features with seamless IT network integration.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/ols/ACS.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "video-surveillance",
    icon: "Camera",
    title: "Video Surveillance",
    short: "Cameras, NVRs and management software tailored to your vertical.",
    description:
      "Our capabilities range from cameras and DVRs, NVRs to video management software and cabling infrastructure. We understand the unique needs of various industries and offer reliable solutions you can bank on.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/ols/CCTV.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "townhall-cafeteria",
    icon: "Coffee",
    title: "Town Hall & Digital Cafeterias",
    short: "Connected spaces for presentations, town halls and team collaboration.",
    description:
      "Today's corporate cafeteria is more than a place to grab lunch — it's a place to connect and collaborate. We design solutions to give presentations, distribute video feeds and conduct team building activities.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/blob-23617de.png/:/rs=w:900,cg:true",
  },
  {
    slug: "smart-classrooms",
    icon: "GraduationCap",
    title: "Smart Classrooms",
    short: "Technology-enhanced learning with displays, tabs and interactive boards.",
    description:
      "We design technology-enhanced learning classrooms that enhance the way of teaching and learning digitally. We integrate classrooms with digital displays, tabs, whiteboards and audio/visual components.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/classroom.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "visitor-management",
    icon: "UserCheck",
    title: "Visitor Management System",
    short: "Professional VMS built on Microsoft .NET — badging, screening and self-registration.",
    description:
      "A leading-edge professional visitor management system built on proven Microsoft .NET technologies. Replace outdated paper logbooks, streamline reception and provide professional badges. Total control in registering, verifying, screening and badging visitors.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/prof-visitor-400x400.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "parking-management",
    icon: "Car",
    title: "Parking Management System",
    short: "Hybrid architecture parking solution integrating gates, barriers and ticketing.",
    description:
      "A powerful solution to parking issues with a simple interface and powerful engine. Integrates with access control like automatic gates, barrier controls, ticketing systems. Hybrid architecture (Server + Client + Web) suits every industry vertical.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/Parking.jpg/:/rs=w:900,cg:true",
  },
  {
    slug: "barriers",
    icon: "Shield",
    title: "Pedestrian & Vehicle Barriers",
    short: "Physical security barriers for public and private industry sectors.",
    description:
      "A wide variety of barriers for different industry sectors. Extensive experience providing physical security solutions globally for both public and private industries, evolved around deep knowledge of pedestrian security barriers.",
    image:
      "https://img1.wsimg.com/isteam/ip/0ed9d86f-1518-4c8b-9bd3-8703aae28eb3/blob-fd56aff.png/:/rs=w:900,cg:true",
  },
];

export const values = [
  {
    icon: "Award",
    title: "Technical Experience",
    text: "Well-versed across IT, audio, video, security systems, networks and databases — with proven delivery on projects of every size.",
  },
  {
    icon: "TrendingUp",
    title: "High ROI",
    text: "Outsource IT management to us and reclaim your budget for growth. We keep your systems humming so you can focus on your business.",
  },
  {
    icon: "Handshake",
    title: "Satisfaction Guaranteed",
    text: "Professional service tailored to your company's needs — regardless of budget — with satisfaction guaranteed on every engagement.",
  },
];

export const industries = [
  "Corporate Offices",
  "Data Centres",
  "Education",
  "Healthcare",
  "Manufacturing",
  "Retail & Malls",
  "Hospitality",
  "Government",
];

export const google = {
  reviewUrl: "https://share.google/3GCQ6QRfg2n9Os2Ro",
  mapsUrl: "https://maps.app.goo.gl/rU3rUf6us6LKe5Dm6",
  rating: 5.0,
  count: 14,
};

export const googleReviews = [
  {
    name: "Dharmendra Nehe",
    rating: 5,
    when: "a year ago",
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjV5bqCfDrDxSu15e8BzD4cAqvqfbLHRdlq3ykKB_m4dFx25RC_xFA=w72-h72-p-rp-mo-br100",
    text: "Best AV solution provider in pune. good experience.",
  },
  {
    name: "Ruturaj Pokale",
    rating: 5,
    when: "a year ago",
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjXV7VMphrxwUPRT69Iv2e9gekICpH9OtYnrj_AItmm7JmlYw6vnSg=w72-h72-p-rp-mo-br100",
    text: "Best Services for Fire Detection and Public Address Systems.",
  },
  {
    name: "Pramod Laddha",
    rating: 5,
    when: "5 years ago",
    avatar: "https://lh3.googleusercontent.com/a/ACg8ocKUlq6NNIGlCgDSGWdh1F35YuSB50hV83gXFmlV2lilqQdCmw=w72-h72-p-rp-mo-br100",
    text: "Excellent service provider. In time, cost effective, updated technological guidance. Wish you all the best Global Tech Solutions.",
    reply: "Thanks sir for your Best Wishes",
  },
];

export const partners = [
  "Cisco",
  "Crestron",
  "Hikvision",
  "Bosch",
  "Honeywell",
  "Extron",
  "Poly",
  "Dahua",
];
